<template>
  <div class="container">
    <el-alert
      :title="title"
      type="info"
      show-icon>
      <el-link type="primary"
               :href="appendToken"
               target="_blank">Mon Compte
      </el-link>
    </el-alert>
  </div>
</template>

<script>
  export default {
    props: {
      title: String,
      link: String,
    },
    computed: {
      appendToken() {
        const shopToken = localStorage.getItem('shopToken').replace('"', '');
        return this.link + shopToken;
      },
    },
  };
</script>

<style lang="stylus">
 .container {
   margin-bottom 20px
 }
</style>
